import { render } from "./Affiliation.vue?vue&type=template&id=00ea8508&scoped=true"
import script from "./Affiliation.vue?vue&type=script&lang=js"
export * from "./Affiliation.vue?vue&type=script&lang=js"

import "./Affiliation.vue?vue&type=style&index=0&id=00ea8508&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00ea8508"]])

export default __exports__